import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const olderSiblingFeelings: BlogMetaData = {
  title: '上の子がかわいくないと感じるとき｜背景・対処法と相談先',
  description:
    '上の子をかわいく思えない、イライラが止まらないときに、比較・疲れ・生活の変化などの背景と対処法を整理。つらさが続く場合や安全が心配な場合の相談先も紹介します。',
  thumbnailUrl: '/img/blog-older-sibling-feelings.webp',
  filePath: buildBlogFilePath('older-sibling-feelings'),
  category: BLOG_CATEGORY.PARENTING,
};
